import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ModalHeader from "./ModalHeader";
import SendPushModal from "./SendPushModal";
import api from "../services/api";
import styles from "./SendPushModal.module.css";
import own from "./AdminSendPushModal.module.css";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";

/**
 * Admin manda push avulso em nome do TreinoNexo (espelha o "Enviar
 * notificação" do professor, SendPushModal). A lista só mostra quem tem
 * dispositivo inscrito: pra quem não tem, a notificação não chegaria.
 */
export default function AdminSendPushModal({ open, onClose }) {
  const [query, setQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  useBodyScrollLock(open && !selected);

  useEffect(() => {
    if (!open) { setQuery(""); setSelected(null); return undefined; }
    let alive = true;
    const id = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.get("/push/admin/recipients", { params: query.trim() ? { q: query.trim() } : {} });
        if (alive) setUsers(res.data || []);
      } catch (_) {
        if (alive) setUsers([]);
      } finally {
        if (alive) setLoading(false);
      }
    }, 250);
    return () => { alive = false; clearTimeout(id); };
  }, [open, query]);

  if (!open) return null;

  if (selected) {
    return (
      <SendPushModal
        open
        onClose={() => setSelected(null)}
        studentId={selected.id}
        studentName={selected.name}
        endpoint={`/push/admin/message-user/${selected.id}`}
        subtitle={`Em nome do TreinoNexo, direto pro celular de ${selected.name}`}
      />
    );
  }

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-labelledby="admin-push-title">
      <div className={styles.modal}>
        <ModalHeader onClose={onClose} />
        <div className={styles.header}>
          <p className={styles.title} id="admin-push-title">Enviar notificação</p>
          <p className={styles.sub}>Em nome do TreinoNexo. Só aparece quem tem o app com notificação ativada.</p>
        </div>
        <div className={styles.body}>
          <input
            type="search"
            className={own.search}
            placeholder="Buscar por nome ou email"
            aria-label="Buscar destinatário"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className={own.list} aria-busy={loading}>
            {loading && <p className={own.empty}><FontAwesomeIcon icon={faSpinner} spin /> Carregando...</p>}
            {!loading && users.map((u) => (
              <button key={u.id} type="button" className={own.row} onClick={() => setSelected(u)}>
                <span className={own.rowMain}>
                  <span className={own.name}>{u.name}</span>
                  <span className={own.email}>{u.email}</span>
                </span>
                <span className={own.devices}>
                  <FontAwesomeIcon icon={faMobileScreen} aria-hidden="true" /> {u.devices}
                </span>
              </button>
            ))}
            {!loading && !users.length && (
              <p className={own.empty}>Ninguém com notificação ativada encontrado.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
